<template>
  <div class="flex gap-5 hide-scroll-bar overflow-scroll py-2 mb-4 px-4">
    <TsMedia
      v-for="item in props.data"
      :key="item.id"
      append-class="shadow-md bg-white px-3.5 py-7 rounded-lg max-sm:block min-w-44"
    >
      <TsMediaStart append-class="mr-0 mb-5 sm:mr-4 sm:mb-0">
        <TsImage
          v-if="item && item.image"
          class="max-sm:mx-auto"
          :src="item.image"
          :alt="item.alt || 'job-companion'"
          :width="item.width"
          :height="item.height"
          loading="lazy"
        />
      </TsMediaStart>
      <TsMediaContent append-class="max-sm:mt-auto">
        <TsTypography append-class="mb-0 text-idle-black" size="sm" :text="item.desc" />
      </TsMediaContent>
    </TsMedia>
  </div>
</template>

<script setup lang="ts">
const TsMediaStart = defineAsyncComponent(() => import('~/components/organisms/TsMediaStart.vue'));
const TsMediaContent = defineAsyncComponent(
  () => import('~/components/organisms/TsMediaContent.vue')
);

defineOptions({
  inheritAttrs: false,
});

interface JobCompanionItem {
  id?: number | string;
  key?: number | string;
  image?: string;
  alt?: string;
  width?: string;
  height?: string;
  desc?: string;
}

type Props = {
  dataTestid?: string;
  appendClass?: string;
  data?: JobCompanionItem[];
  width?: string;
  height?: string;
  alt?: string;
};

const props = withDefaults(defineProps<Props>(), {
  data: () => [
    {
      key: 1,
      desc: '<strong>Low prices every day!</strong> Extensive range in stock, always reliable.',
      image: '/images/low-price.png',
      alt: 'Low prices every day',
      height: '77',
      width: '115',
    },
  ],
  dataTestid: 'carousel-job-companion',
  appendClass: '',
  width: '200',
  height: '250',
  alt: 'job-companion',
});

const random_id = ref('');

onMounted(() => {
  random_id.value = useRandomUUID();
});
</script>
